import { Fragment } from "react";
import { ToggleControl } from '@wordpress/components';
import { InspectorAdvancedControls } from "@wordpress/block-editor";
import { createHigherOrderComponent } from "@wordpress/compose"
import { addFilter } from "@wordpress/hooks";


const blocksList = [
    'core/paragraph',
	'core/heading',
	'core/group',
	'core/image',
	'core/columns',
	'core/column',
	'core/post-title',
	'core/navigation',
	'gss/chart',
	'gss/multi-chart',
	'gss/faq',
	'gss/faqs',
	'gss/tabs',
	'gss/card-link'

];

function addScrollRevealAttribute(settings, name) {
    if (typeof settings.attributes !== 'undefined') {
        if (blocksList.includes(name)) {
            settings.attributes = Object.assign(settings.attributes, {
				scrollReveal: {
					type: 'boolean',
				}
			});
        }
    }
    return settings;
}

addFilter(
	'blocks.registerBlockType',
	'gss/scroll-reveal-attribute',
	addScrollRevealAttribute
);

const scrollRevealSetting = createHigherOrderComponent((BlockEdit) => {
    return (props) => {        
		const { attributes, setAttributes, isSelected } = props;
		return (
			<Fragment>
				<BlockEdit {...props} />
				{isSelected && (blocksList.includes(props.name)) && 
					<InspectorAdvancedControls>
						<ToggleControl
							label="Scroll Reveal"
							checked={!!attributes.scrollReveal}
							onChange={(newval) => setAttributes({ scrollReveal: !attributes.scrollReveal })}
						/>
					</InspectorAdvancedControls>
				}
			</Fragment>
		);
    }
});

addFilter(
    'editor.BlockEdit',
    'gss/scroll-reveal-setting',
    scrollRevealSetting
)

function gssScrollRevealClass(extraProps, blockType, attributes) {
	const { scrollReveal } = attributes;
 
	if (typeof scrollReveal !== 'undefined' && scrollReveal) {
		extraProps.className = (extraProps?.className ?? '') + ' gss-scroll-reveal';
	}
	return extraProps;
}
 
wp.hooks.addFilter(
	'blocks.getSaveContent.extraProps',
	'gss/scroll-reveal-class',
	gssScrollRevealClass
);